import { useLang } from '../../i18n';

// Pure month header + day grid. All availability/selection logic lives in the
// parent — `cells` arrives fully computed (including `extraClass`, e.g. "no-slots today")
// so this component stays presentational and matches the original class-combination rules exactly.
export function CalendarGrid({
  monthLabel, cells, canGoBack, canGoForward, onPrev, onNext,
  prevTestId = 'cal-prev', nextTestId = 'cal-next', gridTestId = 'calendar-grid', dayTestIdPrefix = 'cal-day',
}) {
  const { t } = useLang();
  return (
    <div>
      <div className="mc-header">
        <button type="button" aria-label={t('prevMonth')} data-testid={prevTestId} disabled={!canGoBack} onClick={onPrev}>&lsaquo;</button>
        <div className="mc-month">{monthLabel}</div>
        <button type="button" aria-label={t('nextMonth')} data-testid={nextTestId} disabled={!canGoForward} onClick={onNext}>&rsaquo;</button>
      </div>
      <div className="mc-dow">
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, i) => <span key={i}>{d}</span>)}
      </div>
      <div className="mc-grid" data-testid={gridTestId}>
        {cells.map((c, i) => {
          if (c.day == null) return <div key={c.key || `e${i}`} className="mc-day empty" />;
          const cls = `mc-day ${c.extraClass || ''}`.trim();
          return (
            <div key={c.key} className={cls} data-testid={`${dayTestIdPrefix}-${c.iso}`} onClick={c.onClick}>
              {c.day}
            </div>
          );
        })}
      </div>
    </div>
  );
}
